import {
  getConseilsByPage,
  getRecipes,
  getCircleRecipeList,
  getRecipesByCategoryAndPage,
} from './recipes';

export const apiRecipes = {
  getRecipes,
  getCircleRecipeList,
  getRecipesByCategoryAndPage,
  getConseilsByPage,
};
